import { ApiService } from './apiService';
import { API_ENDPOINTS } from '../config/api';
import {
  LoginRequest,
  LoginResponse,
  ForgotPasswordRequest,
  ResetPasswordRequest,
} from '../types/api';

/**
 * Authentication Service
 */
export class AuthService extends ApiService {
  /**
   * Login user
   */
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    return this.post<LoginResponse>(API_ENDPOINTS.auth.login, credentials);
  }

  /**
   * Logout user
   */
  async logout(): Promise<void> {
    try {
      await this.post(API_ENDPOINTS.auth.logout);
    } catch (error) {
      // Even if logout fails on server, clear local state
      console.error('Logout error:', error);
    }
  }

  /**
   * Refresh access token
   */
  async refreshToken(refreshToken: string): Promise<{ token: string; refreshToken: string }> {
    return this.post<{ token: string; refreshToken: string }>(
      API_ENDPOINTS.auth.refresh,
      { refreshToken }
    );
  }

  async forgotPassword(payload: ForgotPasswordRequest): Promise<void> {
    await this.post(API_ENDPOINTS.auth.forgotPassword, payload);
  }

  async resetPassword(payload: ResetPasswordRequest): Promise<void> {
    await this.post(API_ENDPOINTS.auth.resetPassword, payload);
  }
}

// Export singleton instance
export const authService = new AuthService();

